function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSosDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_50",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m52,23c0,9.09-13.54,30.3-18.34,37.53-.79,1.19-2.53,1.19-3.32,0-4.8-7.23-18.34-28.44-18.34-37.53,0-11.05,8.95-20,20-20s20,8.95,20,20Z",
    style: {
      fill: "#ed1c24"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 23,
    r: 13,
    style: {
      fill: "#f1f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32,10c-.338,0-.669.025-1,.051,6.711.512,12,6.107,12,12.949s-5.289,12.437-12,12.949c.331.025.662.051,1,.051,7.18,0,13-5.82,13-13s-5.82-13-13-13Z",
    style: {
      fill: "#e6e7e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32,3c-.506,0-1.003.039-1.5.076,10.346.769,18.5,9.381,18.5,19.924,0,9.09-13.54,30.3-18.34,37.53-.047.071-.107.123-.16.185.843.987,2.417.934,3.16-.185,4.8-7.23,18.34-28.44,18.34-37.53,0-11.05-8.95-20-20-20Z",
    style: {
      fill: "#d80027"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32,37c-7.72,0-14-6.28-14-14s6.28-14,14-14,14,6.28,14,14-6.28,14-14,14Zm0-26c-6.617,0-12,5.383-12,12s5.383,12,12,12,12-5.383,12-12-5.383-12-12-12Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32,62.426c-1.005,0-1.938-.501-2.496-1.341-5.563-8.385-18.504-28.88-18.504-38.084,0-11.58,9.42-21,21-21s21,9.42,21,21c0,9.204-12.941,29.7-18.505,38.084-.557.84-1.49,1.341-2.495,1.341Zm0-58.426c-10.477,0-19,8.523-19,19,0,8.903,13.908,30.555,18.171,36.979.378.568,1.281.568,1.658,0,4.263-6.424,18.171-28.076,18.171-36.979,0-10.477-8.523-19-19-19Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25,28c-1.654,0-3-1.346-3-3,0-.552.448-1,1-1s1,.448,1,1,.449,1,1,1,1-.449,1-1-.449-1-1-1c-1.654,0-3-1.346-3-3s1.346-3,3-3,3,1.346,3,3c0,.552-.448,1-1,1s-1-.448-1-1-.449-1-1-1-1,.449-1,1,.449,1,1,1c1.654,0,3,1.346,3,3s-1.346,3-3,3Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39,28c-1.654,0-3-1.346-3-3,0-.552.448-1,1-1s1,.448,1,1,.449,1,1,1,1-.449,1-1-.449-1-1-1c-1.654,0-3-1.346-3-3s1.346-3,3-3,3,1.346,3,3c0,.552-.448,1-1,1s-1-.448-1-1-.449-1-1-1-1,.449-1,1,.449,1,1,1c1.654,0,3,1.346,3,3s-1.346,3-3,3Z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32,28c-1.654,0-3-1.346-3-3v-4c0-1.654,1.346-3,3-3s3,1.346,3,3v4c0,1.654-1.346,3-3,3Zm0-8c-.551,0-1,.449-1,1v4c0,.551.449,1,1,1s1-.449,1-1v-4c0-.551-.449-1-1-1Z",
    style: {
      fill: "#231f20"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSosDirection);
export default __webpack_public_path__ + "static/media/sos-direction.1e40e32536cc40fda4739ffed09c9f12.svg";
export { ForwardRef as ReactComponent };